import { gql } from "@apollo/client";
import { EMAIL_AUTOMATION_FIELDS } from "./fragments";

export const CREATE_TRAVEL_EMAIL_AUTOMATION = gql`
  mutation CreateTravelEmailAutomation($request: NotificationAutomationRequestInput!) {
    createTravelEmailAutomation(request: $request) {
      ${EMAIL_AUTOMATION_FIELDS}
    }
  }
`;

export const UPDATE_TRAVEL_EMAIL_AUTOMATION = gql`
  mutation UpdateTravelEmailAutomation($id: String!, $request: NotificationAutomationRequestInput!) {
    updateTravelEmailAutomation(id: $id, request: $request) {
      ${EMAIL_AUTOMATION_FIELDS}
    }
  }
`;

export const SET_TRAVEL_EMAIL_AUTOMATION_ACTIVE = gql`
  mutation SetTravelEmailAutomationActive($id: String!, $isActive: Boolean!) {
    setTravelEmailAutomationActive(id: $id, isActive: $isActive) {
      id
      isActive
      activeSince
      updatedAt
    }
  }
`;

export const DELETE_TRAVEL_EMAIL_AUTOMATION = gql`
  mutation DeleteTravelEmailAutomation($id: String!) {
    deleteTravelEmailAutomation(id: $id)
  }
`;
